import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  function (runtimeConstant, $stateProvider) {
    function run() {
      try {
        $stateProvider
          .state('modules.security', {
            url: '/seguranca',
            templateUrl: 'views/modules/cadastros.html',
            controller: 'securityController',
          })
          .state('modules.security.groups', {
            url: '/grupos',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'Grupos',
              states: {
                create: 'modules.security.groups-new',
                edit: 'modules.security.groups-edit',
                list: 'modules.security.groups',
              },
              permissions: {
                only: ['ADMIN', 'ManageGroups'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'groupCrudService',
            },
          })
          .state('modules.security.groups-new', {
            url: '/grupos/novo',
            templateUrl: 'views/modules/security/groups/new.html',
            controller: 'crudGroupController',
            data: {
              title: 'Grupos',
              crudTitle: 'Novo grupo',
              states: {
                create: false,
                edit: false,
                list: 'modules.security.groups',
              },
              permissions: {
                only: ['ADMIN', 'ManageGroups'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'groupCrudService',
            },
          })
          .state('modules.security.groups-edit', {
            url: '/grupos/editar/:id?tab',
            templateUrl: 'views/modules/security/groups/new.html',
            controller: 'crudGroupController',
            data: {
              title: 'Grupos',
              crudTitle: 'Editar grupo',
              states: {
                create: false,
                edit: false,
                list: 'modules.security.groups',
              },
              permissions: {
                only: ['ADMIN', 'ManageGroups'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'groupCrudService',
            },
          })
          .state('modules.security.users', {
            url: '/usuarios',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'USERS',
              states: {
                create: 'modules.security.users-new',
                edit: 'modules.security.users-edit',
                list: 'modules.security.users',
              },
              permissions: {
                only: ['ADMIN', 'ManageUsers'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'userCrudService',
            },
          })
          .state('modules.security.users-new', {
            url: '/usuarios/novo',
            templateUrl: 'views/modules/security/users/new.html',
            controller: 'crudController',
            data: {
              title: 'USERS',
              crudTitle: 'NEW USER',
              states: {
                create: false,
                edit: false,
                list: 'modules.security.users',
              },
              permissions: {
                only: ['ADMIN', 'ManageUsers'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'userCrudService',
            },
          })
          .state('modules.security.users-edit', {
            url: '/usuarios/editar/:id?selectedTab=:tab',
            templateUrl: 'views/modules/security/users/new.html',
            controller: 'crudController',
            data: {
              title: 'USERS',
              crudTitle: 'EDIT USER',
              states: {
                create: false,
                edit: false,
                list: 'modules.security.users',
              },
              permissions: {
                only: ['ADMIN', 'ManageUsers'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'userCrudService',
            },
          })
          .state('modules.security.roles', {
            url: '/papeis',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'ROLES',
              states: {
                create: 'modules.security.roles-new',
                edit: 'modules.security.roles-edit',
                list: 'modules.security.roles',
              },
              customDeleteMessage: 'CONFIRM REMOVE ROLES',
              permissions: {
                only: ['ADMIN', 'ManageRoles'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'roleCrudService',
            },
          })
          .state('modules.security.roles-new', {
            url: '/papeis/novo',
            templateUrl: 'views/modules/security/roles/new.html',
            controller: 'crudController',
            data: {
              title: 'ROLES',
              crudTitle: 'NEW ROLE',
              states: {
                create: false,
                edit: false,
                list: 'modules.security.roles',
              },
              permissions: {
                only: ['ADMIN', 'ManageRoles'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'roleCrudService',
            },
          })
          .state('modules.security.roles-edit', {
            url: '/papeis/editar/:id',
            templateUrl: 'views/modules/security/roles/new.html',
            controller: 'crudController',
            data: {
              title: 'ROLES',
              crudTitle: 'EDIT ROLE',
              states: {
                create: false,
                edit: false,
                list: 'modules.security.roles',
              },
              permissions: {
                only: ['ADMIN', 'ManageRoles'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'roleCrudService',
            },
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
